<script lang="ts">
  import { Link } from "svelte-navigator";
  import { nextShortcode, prevShortcode } from "./stores";
</script>

{#if $prevShortcode}
  <Link to="/art/{$prevShortcode}" alt="Previous image">
    <div class="prev">&#8617;</div>
  </Link>
{/if}

{#if $nextShortcode}
  <Link to="/art/{$nextShortcode}" alt="Next image"
    ><div class="next">&#8618;</div>
  </Link>
{/if}

<style>
  div.prev,
  div.next {
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: start;
    font-size: 5rem;
    color: #faf9f9;
    padding: 1.5rem 1rem 1rem 1rem;
  }

  div.prev {
    right: 50%;
    left: 0;
    justify-content: flex-start;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.25),
      rgba(0, 0, 0, 0)
    );
  }

  div.next {
    right: 1px;
    left: 50%;
    justify-content: flex-end;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));
  }

  div.next:hover,
  div.next:active,
  div.prev:hover,
  div.prev:active {
    opacity: 1;
  }
</style>
